import { UserType } from '../../../../../types/UserType';
import type { CancelPopupText } from '../../../../common/CancelPopup/CancelPopup';
import { translate } from '../../../../common/helpers/translate.helper';
import { OfferState } from '../../../model/OfferState';

interface GetOfferCancelPopupTextProps {
    userType: UserType;
    offerState: string;
}

export const getOfferCancelPopupText = ({ userType, offerState }: GetOfferCancelPopupTextProps): CancelPopupText => {
    if (userType === UserType.CUSTOMER) {
        if (offerState === OfferState.CONFIRMED) {
            return {
                headline: translate('offer.detail.header.actions.cancelPopup.customer.confirmed.headline'),
                description: translate('offer.detail.header.actions.cancelPopup.customer.confirmed.description'),
                buttonText: translate('offer.detail.header.actions.cancelPopup.customer.confirmed.button'),
                acknowledgement: translate(
                    'offer.detail.header.actions.cancelPopup.customer.confirmed.acknowledgement'
                ),
            };
        }

        return {
            headline: translate('offer.detail.header.actions.cancelPopup.customer.headline'),
            description: translate('offer.detail.header.actions.cancelPopup.customer.description'),
            buttonText: translate('offer.detail.header.actions.cancelPopup.customer.button'),
        };
    }

    if (offerState === OfferState.ENQUIRY) {
        return {
            headline: translate('offer.detail.header.actions.cancelPopup.enquiry.headline'),
            description: translate('offer.detail.header.actions.cancelPopup.enquiry.description'),
            buttonText: translate('offer.detail.header.actions.cancelPopup.enquiry.button'),
        };
    }

    if (offerState === OfferState.QUOTED) {
        return {
            headline: translate('offer.detail.header.actions.cancelPopup.quoted.headline'),
            description: translate('offer.detail.header.actions.cancelPopup.quoted.description'),
            buttonText: translate('offer.detail.header.actions.cancelPopup.quoted.button'),
        };
    }

    return {
        headline: translate('offer.detail.header.actions.cancelPopup.order.headline'),
        description: translate('offer.detail.header.actions.cancelPopup.order.description'),
        buttonText: translate('offer.detail.header.actions.cancelPopup.order.button'),
    };
};
